import { useEffect } from "react";

export function useClearErrorOnChange<T>(
  value: T,
  key: keyof typeof errors,
  errors: { [key: string]: string | undefined },
  setErrors: React.Dispatch<React.SetStateAction<typeof errors>>
) {
  useEffect(() => {
    if (value && errors[key]) {
      setErrors((prev) => ({ ...prev, [key]: undefined }));
    }
  }, [value, errors[key]]);
}
